import {
    DeviceConfigurationInstance,
    DeviceLayoutConfigSectionDetails,
    DeviceLayoutConfiguration,
    DeviceLayoutDependencies,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-layout/settings-devices-configuration-layout.model';
import { createContext } from 'react';
import { DeviceConfigurationValidity } from './device-configuration.type';

export type ConfigurationDetailContextType = {
    layoutSections?: DeviceLayoutConfiguration;
    dependencies: DeviceLayoutDependencies[];
    layoutSectionSelected?: string;
    sectionDetails?: DeviceLayoutConfigSectionDetails;
    isLoading?: boolean;
    deviceConfigurationInstance: DeviceConfigurationInstance;
    hasConfigChanged: boolean;
    deviceConfigurationValidation: DeviceConfigurationValidity;
    setHasConfigChanged: (hasConfigChanged: boolean) => void;
    setDeviceConfigurationInstance: (instance: Partial<DeviceConfigurationInstance>) => void;
    setIsLoading: (isLoading: boolean) => void;
    setSectionDetails: (sectionDetails: DeviceLayoutConfigSectionDetails | undefined) => void;
    setLayoutSectionSelected: (sectionId: string | undefined) => void;
    setDeviceConfigurationValidation: (validation: DeviceConfigurationValidity) => void;
};

export const ConfigurationDetailContext = createContext<ConfigurationDetailContextType | undefined>(undefined);
